export const en = {
  'networks.tab': 'Security',
  'networks.title': 'Allowed networks',
  'networks.description':
    "The addresses your staff work from, such as the reception computer's internet connection. Away from them, staff other than owners, admins and gym general managers can only look things up and handle their own leave, hours and shifts. With no addresses listed, nobody is limited.",
  'networks.empty': 'No networks yet: staff can work from anywhere.',
  'networks.cidr': 'Address or range',
  'networks.cidrHint': 'One address, such as 203.0.113.7, or a range, such as 203.0.113.0/24. IPv6 works too.',
  'networks.label': 'Label',
  'networks.labelPlaceholder': 'Front desk',
  'networks.addedBy': 'Added by',
  'networks.addedOn': 'Added',
  'networks.add': 'Add',
  'networks.added': 'Network added',
  'networks.remove': 'Remove',
  'networks.removed': 'Network removed',
  'networks.removeTitle': 'Remove {cidr}?',
  'networks.removeBody': 'Staff working from this address keep only looking things up and their own leave, hours and shifts, unless another entry covers it. With no entries left, nobody is limited.',
  'networks.yourAddress': 'Your address: {address}',
  'networks.listed': 'On the list',
  'networks.notListed': 'Not on the list',
  'networks.addYours': 'Add this address',
  'networks.outsideTitle': 'Leave out your own address?',
  'networks.outsideBody': 'The list would not include {address}, the address you are working from now. Staff here would only be able to look things up. Owners, admins and gym general managers are never limited.',
  'networks.outsideConfirm': 'Save anyway',
  'offSite.banner': 'Away from the gym: view only. You can still request leave, log your hours and swap shifts.',
};

export const ka: Record<keyof typeof en, string> = {
  'networks.tab': 'უსაფრთხოება',
  'networks.title': 'ნებადართული ქსელები',
  'networks.description':
    'მისამართები, საიდანაც თქვენი პერსონალი მუშაობს, მაგალითად მიმღების კომპიუტერის ინტერნეტი. მათ გარეთ პერსონალს, გარდა მფლობელების, ადმინისტრატორებისა და დარბაზის გენერალური მენეჯერებისა, მხოლოდ ინფორმაციის ნახვა და საკუთარი შვებულების, საათებისა და ცვლების მართვა შეუძლია. თუ სიაში მისამართი არ არის, არავინ იზღუდება.',
  'networks.empty': 'ქსელები ჯერ არ არის: პერსონალს ნებისმიერი ადგილიდან შეუძლია მუშაობა.',
  'networks.cidr': 'მისამართი ან დიაპაზონი',
  'networks.cidrHint': 'ერთი მისამართი, მაგალითად 203.0.113.7, ან დიაპაზონი, მაგალითად 203.0.113.0/24. IPv6-იც მუშაობს.',
  'networks.label': 'დასახელება',
  'networks.labelPlaceholder': 'მიმღები',
  'networks.addedBy': 'დაამატა',
  'networks.addedOn': 'დაემატა',
  'networks.add': 'დამატება',
  'networks.added': 'ქსელი დაემატა',
  'networks.remove': 'წაშლა',
  'networks.removed': 'ქსელი წაიშალა',
  'networks.removeTitle': 'წავშალოთ {cidr}?',
  'networks.removeBody': 'ამ მისამართიდან მომუშავე პერსონალს დარჩება მხოლოდ ინფორმაციის ნახვა და საკუთარი შვებულების, საათებისა და ცვლების მართვა, თუ მას სხვა ჩანაწერი არ მოიცავს. თუ ჩანაწერი აღარ დარჩება, არავინ შეიზღუდება.',
  'networks.yourAddress': 'თქვენი მისამართი: {address}',
  'networks.listed': 'სიაშია',
  'networks.notListed': 'სიაში არ არის',
  'networks.addYours': 'ამ მისამართის დამატება',
  'networks.outsideTitle': 'თქვენი მისამართი სიიდან დარჩეს გარეთ?',
  'networks.outsideBody': 'სიაში არ იქნება {address} — მისამართი, საიდანაც ახლა მუშაობთ. აქედან პერსონალი მხოლოდ ინფორმაციის ნახვას შეძლებს. მფლობელები, ადმინისტრატორები და დარბაზის გენერალური მენეჯერები არასდროს იზღუდებიან.',
  'networks.outsideConfirm': 'მაინც შენახვა',
  'offSite.banner': 'დარბაზის გარეთ ხართ: მხოლოდ ნახვა. შვებულების მოთხოვნა, საათების აღრიცხვა და ცვლების გაცვლა მაინც შეგიძლიათ.',
};
